const id = {
  nav: {
    home: "Beranda",
    about: "Tentang",
    services: "Layanan Maklon",
    products: "Produk",
    articles: "Artikel",
    gallery: "Galeri",
    faq: "FAQ",
    contact: "Kontak",
    orderSample: "Order Sample",
    career: "Karir",
    live: "Live",
    consult: "Konsultasi Gratis",
    startMaklon: "Mulai Maklon!",
    more: "Lainnya",
  },
  common: {
    chatWhatsApp: "Chat WhatsApp",
    sendMessage: "Kirim Pesan",
    learnMore: "Pelajari",
    loading: "Loading...",
    filterAll: "Semua",
    share: "Bagikan:",
    readMinutes: "{n} menit baca",
    backHome: "Kembali ke Beranda",
    consultWa: "Konsultasi via WhatsApp",
    close: "Tutup",
    announcement: "Pengumuman",
    promo: "Promo",
    location: "Lokasi",
  },
  footer: {
    company: "Perusahaan",
    help: "Bantuan",
    contact: "Kontak",
    aboutUs: "Tentang Kami",
    whatsappUs: "WhatsApp Kami",
    rights: "Semua Hak Dilindungi.",
    servicesLine: "Maklon Minuman Serbuk Fungsional · Private Label · OEM · ODM · Contract Manufacturing",
    taglineFallback: "Maklon Minuman Serbuk Fungsional Berkualitas — mitra strategis bagi brand F&B Indonesia untuk inovasi, kualitas, dan pertumbuhan.",
  },
  home: {
    seoTitle: "Maklon Minuman Serbuk Fungsional Terpercaya",
    seoDesc: "PT Mandala Cahaya Sentosa — pabrik maklon minuman serbuk fungsional, private label, OEM, ODM & contract manufacturing sejak 2008. MOQ terjangkau, BPOM & Halal.",
    badge: "Pabrik Maklon Terpercaya Sejak 2008",
    titleBefore: "Wujudkan ",
    titleHighlight: "Brand Minuman",
    titleAfter: " Impian Anda Bersama Kami",
    lead: "Dari ide hingga produk siap jual, PT Mandala Cahaya Sentosa adalah mitra maklon minuman serbuk fungsional terpercaya untuk inovasi, kualitas, dan pertumbuhan bisnis F&B di Indonesia.",
    ctaCatalog: "Lihat Katalog Produk",
    statYears: "Tahun Pengalaman",
    statBrands: "Brand Klien",
    statSince: "Berdiri Sejak 2008",
    statLegal: "BPOM, Halal & ISO",
    heroSubtitle: "Dari Ide Produk Hingga Siap Dipasarkan",
    statFormulas: "Formula Sukses",
    statProducts: "Produk Launching",
    certsOverline: "Tersertifikasi & Terpercaya",
    servicesOverline: "Layanan Kami",
    servicesTitle: "Solusi End-to-End untuk Brand Minuman Anda",
    servicesSubtitle: "Kami memahami tantangan Anda: formulasi rumit, biaya pabrik mahal, hingga proses BPOM & Halal panjang. Mandala hadir sebagai solusi end-to-end yang mengubah ide menjadi produk siap jual.",
    whyOverline: "Keunggulan Kami",
    whyTitleBefore: "Mengapa ",
    whyTitleHighlight: "Mandala Cahaya Sentosa",
    whyTitleAfter: " dipercaya ratusan brand?",
    whyBody: "Pengalaman lebih dari 10 tahun dan komitmen pada kualitas menjadikan kami mitra pilihan untuk brand minuman serbuk fungsional di Indonesia.",
    whyCta: "Lebih Banyak Tentang Kami",
    processOverline: "Alur Proses",
    processTitle: "5 Langkah Sederhana Menuju Produk Siap Jual",
    processSubtitle: "Kami merancang alur kerja transparan dan terstruktur agar Anda selalu mengetahui setiap tahapan perjalanan produk.",
    productsOverline: "Kategori Produk",
    productsTitle: "Produk Unggulan Kami",
    productsSubtitle: "Berbagai kategori minuman serbuk fungsional yang bisa Anda maklon dengan formulasi custom sesuai brand Anda.",
    seeAllProducts: "Lihat Semua Produk",
    productDetail: "Detail Produk",
    testimonialsOverline: "Testimoni Klien",
    testimonialsTitle: "Dipercaya oleh Ratusan Brand di Indonesia",
    ctaOverline: "Siap Memulai?",
    ctaTitle: "Tertarik dengan Layanan Maklon Minuman Kami?",
    ctaBody: "Hubungi tim marketing kami untuk konsultasi gratis. Kami siap membantu mewujudkan brand minuman impian Anda.",
    services: [
      { title: "Maklon Minuman Serbuk", desc: "Ciptakan produk minuman kesehatan, kecantikan, atau fungsional dengan formula eksklusif dan bahan baku berkualitas." },
      { title: "Private Label", desc: "Solusi label private untuk brand Anda dengan pilihan formulasi standar yang telah teruji pasar." },
      { title: "Contract Manufacturing", desc: "Manufaktur skala besar dengan standar mutu tinggi. Konsistensi rasa & kemasan terjamin." },
      { title: "OEM & ODM", desc: "Layanan lengkap dari desain formula hingga kemasan siap edar sesuai spesifikasi brand Anda." },
      { title: "Riset & Pengembangan", desc: "Tim R&D berpengalaman mengembangkan formula inovatif sesuai tren dan target market." },
      { title: "Konsultasi Legalitas", desc: "Bantuan pengurusan izin BPOM, sertifikat Halal MUI, dan semua legalitas produk." },
    ],
    advantages: [
      { title: "MOQ Terjangkau", desc: "Mulai dari 1.000 box, cocok untuk brand pemula & UMKM." },
      { title: "Legalitas Lengkap", desc: "BPOM & Halal MUI kami urus hingga selesai." },
      { title: "Konsultasi Gratis", desc: "Diskusikan ide produk minuman Anda tanpa biaya awal." },
      { title: "Produksi Cepat", desc: "Proses efisien dengan standar tinggi, siap launching lebih cepat." },
      { title: "Tim Expert R&D", desc: "1000+ formula sukses sesuai tren pasar Indonesia." },
      { title: "Sample Terjamin", desc: "Uji coba sample gratis hingga sesuai keinginan Anda." },
    ],
    process: [
      { t: "Konsultasi & Ide Produk", d: "Sampaikan ide atau kebutuhan Anda. Tim kami analisis tren, formula, dan peluang pasar." },
      { t: "Formulasi & Sampel", d: "Tim R&D mengembangkan sampel sesuai permintaan, dikirim untuk uji & persetujuan." },
      { t: "Desain & Legalitas", d: "Gratis desain kemasan sesuai brand, sekaligus pengurusan BPOM & Halal." },
      { t: "Produksi & Quality Check", d: "Produksi massal di pabrik berstandar tinggi, dikemas, melewati kontrol kualitas ketat." },
      { t: "Pengiriman Produk", d: "Produk siap dikirim tepat waktu ke lokasi Anda, siap dipasarkan." },
    ],
  },
  about: {
    seoTitle: "Tentang Kami",
    seoDesc: "Berdiri sejak 2008, PT Mandala Cahaya Sentosa adalah mitra maklon minuman serbuk fungsional terpercaya di Indonesia dengan sertifikasi BPOM, Halal, GMP, HACCP, ISO 9001 & ISO 22000.",
    overline: "Tentang Kami",
    heroTitle: "Lebih dari 10 Tahun Menjadi Mitra Terpercaya Brand F&B Indonesia",
    heroLead: "PT Mandala Cahaya Sentosa adalah perusahaan manufaktur maklon minuman serbuk fungsional yang berdedikasi menjadi mitra strategis bagi para pengusaha F&B, dari startup rintisan hingga perusahaan multinasional.",
    storyOverline: "Cerita Kami",
    storyTitle: "Dari Ide Menjadi Produk Siap Pasar",
    storyP1: "Berdiri sejak 2008, Mandala Cahaya Sentosa tumbuh menjadi salah satu pabrik maklon minuman serbuk fungsional terpercaya di Indonesia. Kami mendukung setiap tahap perjalanan produk klien: mulai dari konsultasi awal, formulasi custom, pembuatan sampel, pengurusan legalitas BPOM & Halal, hingga produksi massal dan pengiriman.",
    storyP2: "Dengan fasilitas produksi berstandar tinggi (GMP, HACCP, ISO 9001, ISO 22000) dan tim R&D berpengalaman, kami telah menghasilkan lebih dari 1000 formula unik yang tersebar di berbagai brand minuman serbuk fungsional, kolagen, kopi, teh, cokelat, dan herbal tradisional.",
    storyP3: "Visi kami: menjadi perusahaan terkemuka di tingkat nasional dan internasional dalam bidang makanan, minuman, dan suplemen tradisional.",
    imgAlt: "Pabrik Mandala",
    valuesOverline: "Visi Misi Nilai",
    valuesTitle: "Landasan Kerja Kami",
    vision: "Visi",
    visionDesc: "Menjadi perusahaan terkemuka di tingkat nasional dan internasional dalam bidang makanan, minuman, dan suplemen tradisional.",
    mission: "Misi",
    missionDesc: "Menjadi penyedia jasa pembuatan minuman fungsional.\nMengutamakan kualitas dalam setiap tindakan dan proses.\nMengembangkan inovasi produk baru sesuai tren masyarakat dengan tetap menjaga keamanan pangan.\nMeningkatkan keterampilan serta pengetahuan karyawan demi performa operasional maksimal.\nMemperluas jaringan usaha melalui lokasi strategis guna menjadi yang terbaik di Indonesia.",
    values: "Nilai",
    valuesDesc: "Integritas, Inovasi, Kualitas, Kepercayaan Klien, dan Kolaborasi menjadi pegangan utama dalam setiap interaksi.",
    certOverline: "Sertifikasi",
    certTitle: "Standar Kualitas Kelas Dunia",
    certSubtitle: "Semua sertifikasi yang menjamin kualitas, keamanan, dan kredibilitas produk minuman serbuk yang kami produksi.",
    certs: [
      { c: "BPOM", d: "Badan Pengawas Obat & Makanan" },
      { c: "HALAL", d: "MUI Indonesia" },
      { c: "GMP", d: "Good Manufacturing Practice" },
      { c: "HACCP", d: "Hazard Analysis" },
      { c: "ISO 9001", d: "Quality Management" },
      { c: "ISO 22000", d: "Food Safety" },
    ],
    ctaTitle: "Siap berkolaborasi dengan kami?",
    ctaBody: "Diskusikan konsep produk minuman Anda bersama tim ahli kami.",
  },
  services: {
    seoTitle: "Layanan Maklon Minuman Serbuk",
    seoDesc: "Layanan lengkap: Maklon Minuman Serbuk, Private Label, OEM/ODM, Contract Manufacturing, R&D, dan Pengurusan Legalitas BPOM & Halal untuk brand F&B Indonesia.",
    overline: "Layanan Maklon",
    heroTitle: "Solusi Lengkap untuk Menghadirkan Brand Minuman Anda",
    heroLead: "Dari maklon standar, private label, OEM/ODM, hingga contract manufacturing skala besar — semua ditangani dalam satu atap dengan standar kualitas tinggi.",
    items: [
      { title: "Maklon Minuman Serbuk", desc: "Layanan maklon lengkap untuk kategori minuman serbuk fungsional. Kami membantu dari riset formula hingga produksi massal.", bullets: ["Formulasi custom sesuai brief", "MOQ mulai 1.000 box", "Free desain kemasan", "Bantuan BPOM & Halal"] },
      { title: "Private Label", desc: "Solusi cepat untuk membangun brand minuman Anda menggunakan formula standar yang telah teruji pasar.", bullets: ["Formula ready-stock", "Time to market cepat", "Investasi minimal", "Custom branding"] },
      { title: "OEM & ODM", desc: "Original Equipment / Design Manufacturing untuk brand yang ingin mengontrol setiap detail spesifikasi produk.", bullets: ["Custom formulation", "Custom packaging design", "Kerahasiaan formula (NDA)", "Kontrol kualitas ketat"] },
      { title: "Contract Manufacturing", desc: "Produksi skala besar dengan standar mutu tinggi. Cocok untuk brand yang ingin scale up produksinya.", bullets: ["Kapasitas produksi besar", "Konsistensi mutu", "Efisiensi biaya", "Kontrak jangka panjang"] },
      { title: "Riset & Pengembangan", desc: "Tim R&D kami membantu mengembangkan formula inovatif sesuai tren pasar dan target konsumen Anda.", bullets: ["1000+ formula sukses", "Trend analysis", "Sample development", "Uji stabilitas & sensori"] },
      { title: "Legalitas & Sertifikasi", desc: "Kami membantu mengurus semua legalitas produk hingga siap edar di pasar Indonesia.", bullets: ["BPOM MD / TR", "Sertifikasi Halal MUI", "Barcode & label edar", "Pendampingan penuh"] },
    ],
  },
  products: {
    seoTitle: "Katalog Produk Minuman Serbuk",
    seoDesc: "Katalog produk minuman serbuk yang bisa Anda maklon: Collagen, Kopi, Herbal, Fiber, Cokelat, Ice Cream, Milkshake, dan formulasi custom lainnya.",
    overline: "Produk Kami",
    heroTitle: "Katalog Produk Minuman Serbuk yang Bisa Anda Maklon",
    heroLead: "Semua produk dapat dikustomisasi sesuai formulasi, rasa, kemasan, dan target market Anda.",
    detail: "Detail Produk",
    empty: "Belum ada produk pada kategori ini.",
    notFound: "Produk tidak ditemukan.",
    back: "Kembali ke Produk",
    benefits: "Benefit & Keunggulan",
    specs: "Spesifikasi",
    related: "Produk Lainnya",
    waInterest: "Halo, saya tertarik dengan produk *{name}* di mandala.co.id. Mohon info lebih lanjut.",
  },
  articles: {
    seoTitle: "Artikel & Insights",
    seoDesc: "Artikel seputar tren industri minuman serbuk, tips membangun brand F&B, legalitas BPOM & Halal, dan insight maklon dari PT Mandala Cahaya Sentosa.",
    overline: "Artikel",
    heroTitle: "Artikel & Insights Industri Minuman",
    heroLead: "Tips, tren, dan panduan praktis untuk membantu bisnis minuman serbuk Anda berkembang.",
    readMore: "Baca Selengkapnya",
    empty: "Belum ada artikel.",
    notFound: "Artikel tidak ditemukan.",
    back: "Kembali ke Artikel",
    related: "Artikel Terkait",
  },
  gallery: {
    seoTitle: "Galeri",
    seoDesc: "Dokumentasi Staff, Rnd, Produksi, dan Event PT Mandala Cahaya Sentosa.",
    overline: "Galeri",
    heroTitle: "Galeri Fasilitas & Event",
    heroLead: "Album Staff, Rnd, Produksi, dan Event — termasuk dokumentasi YouTube & Instagram.",
    empty: "Belum ada foto.",
  },
  faq: {
    seoTitle: "Pertanyaan yang Sering Ditanyakan (FAQ)",
    seoDesc: "Jawaban lengkap seputar layanan maklon minuman serbuk: MOQ, waktu produksi, custom formula, sertifikasi BPOM & Halal, dan cara memulai kerjasama.",
    overline: "FAQ",
    heroTitle: "Pertanyaan yang Sering Ditanyakan",
    heroLead: "Punya pertanyaan seputar layanan maklon minuman kami? Cek dulu daftar FAQ ini, mungkin jawabannya sudah tersedia.",
    empty: "Belum ada FAQ.",
    stillTitle: "Masih punya pertanyaan?",
    stillBody: "Tim kami siap membantu via WhatsApp atau kirim pesan langsung.",
  },
  contact: {
    seoTitle: "Hubungi Kami",
    seoDesc: "Konsultasi gratis dengan tim marketing PT Mandala Cahaya Sentosa. Kami membantu mewujudkan brand minuman serbuk Anda dari ide hingga produk siap jual.",
    overline: "Hubungi Kami",
    heroTitle: "Mari Diskusikan Produk Impian Anda",
    heroLead: "Lengkapi form di bawah dan tim Mandala akan menghubungi Anda untuk konsultasi gratis.",
    infoTitle: "Informasi Kontak",
    infoLead: "Terhubung langsung dengan tim marketing kami.",
    address: "Alamat Pabrik",
    phone: "Telepon / WhatsApp",
    email: "Email",
    hours: "Jam Operasional",
    formTitle: "Kirim Pesan",
    formHint: "Semua field kecuali tanda (*) adalah opsional.",
    name: "Nama Lengkap *",
    emailField: "Email",
    whatsapp: "Nomor WhatsApp",
    company: "Nama Perusahaan / Brand",
    productPlan: "Rencana Produk",
    productPlaceholder: "Contoh: Minuman collagen sachet 15g",
    message: "Pesan *",
    sending: "Mengirim...",
    errorRequired: "Nama dan pesan wajib diisi",
    success: "Pesan Anda telah terkirim. Kami akan menghubungi Anda segera.",
    errorSend: "Gagal mengirim pesan",
  },
  notFound: {
    seoTitle: "Halaman Tidak Ditemukan",
    title: "Halaman Tidak Ditemukan",
    body: "Halaman yang Anda cari tidak tersedia atau telah dipindahkan.",
  },
  orderSample: {
    seoTitle: "Order Sample Minuman Serbuk",
    seoDesc: "Order sample minuman serbuk di PT Mandala Cahaya Sentosa. Biaya Rp 100.000/formula, 100 gram (4–5 sachet), revisi 1x gratis.",
    overline: "Order Sample",
    title: "Pembuatan Sample Minuman Serbuk",
    lead: "Uji formula brand Anda sebelum produksi massal. Sample siap dikirim dalam bentuk sachet praktis.",
    imgAlt: "Sampel produk minuman serbuk Mandala",
    termsTitle: "Ketentuan Sample",
    terms: [
      "Biaya Rp 100.000 / formula",
      "Sample yang didapatkan 100 gram, terdiri dari 4–5 sachet dengan berat 20–25 gram per sachet",
    ],
    freeBadge: "Revisi Gratis",
    freeNote: "Jika sample pertama kurang sesuai, Anda bisa mendapatkan Sample Revisi 1 kali secara GRATIS, tanpa biaya tambahan.",
    cta: "Order Sample via WhatsApp",
  },
  career: {
    seoTitle: "Karir",
    seoDesc: "Poster lowongan kerja PT Mandala Cahaya Sentosa. Lihat peluang karir terbaru.",
    overline: "Karir",
    title: "Lowongan Kerja",
    lead: "Poster lowongan terbaru dari PT Mandala Cahaya Sentosa.",
    empty: "Belum ada lowongan yang dipublikasikan.",
  },
  live: {
    seoTitle: "Live",
    seoDesc: "Tonton live YouTube & TikTok PT Mandala Cahaya Sentosa.",
    overline: "Live",
    title: "Live Mandala",
    lead: "Saksikan live terbaru dan arsip live sebelumnya dari YouTube & TikTok.",
    empty: "Belum ada live yang dipublikasikan.",
    openYoutube: "Buka di YouTube",
    openTiktok: "Buka di TikTok",
  },
  popup: {
    defaultButton: "Selengkapnya",
  },
};

export default id;
